import { Box, Button, Divider, Paper, Stack, TextField, Typography } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import Loader3D from "../../../../../components/Loader/Loader3D";
import {
  getLeaveAplictionsforReportingHead,
  getWorkFromHomeTasks,
  reportingHeadTaskUpdate,
  taskApproveOrReject,
} from "../../../../../redux/features/leaveSlice";
import { useSelector } from "react-redux";

const WfhActions = ({ open, setOpen, formattedDate, rowData, loading }) => {
  const disabled = rowData.hod_status == 1 || rowData.hod_status == -1;
  const { wfhTasks } = useSelector((state) => state.leave);
  const userTasks = wfhTasks || [];
  const headTasks = wfhTasks?.headCreatedTasks || [];
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  useEffect(() => {
    if (open) {
      dispatch(getWorkFromHomeTasks({ leaveAppId: rowData?.leaveId, isHead: true }));
    }
  }, [open]);

  const initialValues = {
    headTasks: [],
  };
  const schema = Yup.object({
    // headTasks: Yup.string().required("Payment per session is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const updateTaskFunction = () => {
    const invalidTask = formik.values.headTasks.find((task) => !task.task_name || task.task_name.trim() === "");
    if (invalidTask) {
      setError("Task name is required for all tasks");
      return;
    }

    setError("");
    const tasks = formik.values.headTasks.map((task, index) => {
      return { task_name: task.task_name };
    });
    const structured = { data: tasks };
    dispatch(reportingHeadTaskUpdate({ data: structured, leaveId: rowData?.leaveId })).then((res) => {
      if (res.payload.status === "error") {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      } else if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        formik.resetForm();
        dispatch(getWorkFromHomeTasks({ leaveAppId: rowData?.leaveId, isHead: true }));
      }
    });
  };

  const approveOrReject = (value) => {
    dispatch(taskApproveOrReject({ value, leaveId: rowData?.leaveId })).then((res) => {
      if (res.payload.status === "error") {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      } else if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        dispatch(getLeaveAplictionsforReportingHead(formattedDate));
        handleCancel();
      }
    });
  };

  return (
    <GlobalDialog
      maxWidth={"md"}
      fullWidth
      title={"WFH Tasks And Actions"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        open ? (
          loading ? (
            <Loader3D />
          ) : (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Paper elevation={5} sx={{ p: 2, mb: 2 }}>
                      <Typography variant="overline" gutterBottom>
                        Tasks
                      </Typography>

                      <Stack mt={1} spacing={1}>
                        {userTasks.map((task, index) => (
                          <Stack
                            key={task?.sl_no}
                            // display="flex"
                            // alignItems="center"
                            // justifyContent="space-between"
                            p={1.5}
                            borderRadius={2}
                            sx={{ backgroundColor: "#f5f5f5", boxShadow: 1 }}
                          >
                            {/* Left Side: Index and Task Name */}
                            <Typography textTransform={"capitalize"} variant="body1" fontWeight="500">
                              {index + 1}. {task?.task_name}
                            </Typography>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                              <Typography variant="body2" color="text.secondary">
                                Created by {task?.created_by_name}
                              </Typography>
                              <Typography
                                fontWeight="500"
                                variant="body2"
                                sx={{
                                  color: task.status === 0 ? "error.main" : task.status === 1 ? "success.main" : "warning.main",
                                }}
                              >
                                {task?.status_name}
                              </Typography>
                            </Box>

                            {/* Right Side: Created By */}
                          </Stack>
                        ))}
                      </Stack>
                    </Paper>

                    <Stack gap={2}>
                      <Paper elevation={5} sx={{ p: 2, mb: 2 }}>
                        <Stack mt={1} spacing={1}>
                          {formik.values.headTasks.map((task, index) => (
                            <Stack key={index} direction="row" spacing={1} alignItems="center">
                              <TextField
                                type="text"
                                autoComplete="off"
                                fullWidth
                                label={`Task - ${index + 1}`}
                                value={task.task_name}
                                onChange={(e) => {
                                  const updatedTasks = [...formik.values.headTasks];
                                  updatedTasks[index].task_name = e.target.value;
                                  formik.setFieldValue("headTasks", updatedTasks);
                                }}
                                error={Boolean(error)}
                                helperText={error}
                              />

                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => {
                                  const updatedTasks = formik.values.headTasks.filter((_, i) => i !== index);
                                  formik.setFieldValue("headTasks", updatedTasks);
                                }}
                              >
                                Remove
                              </Button>
                            </Stack>
                          ))}

                          <Button
                            disabled={disabled || loading}
                            sx={{ boxShadow: "none" }}
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => {
                              const newTask = {
                                task_name: "",
                              };
                              formik.setFieldValue("headTasks", [...formik.values.headTasks, newTask]);
                            }}
                          >
                            + Add Task
                          </Button>
                          <Button
                            sx={{ boxShadow: "none" }}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={updateTaskFunction}
                            disabled={disabled || loading}
                          >
                            Update Task
                          </Button>
                        </Stack>
                      </Paper>
                    </Stack>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <Stack direction={"row"} spacing={1}>
                      <Button
                        disabled={disabled || loading}
                        sx={{ boxShadow: "none" }}
                        color="error"
                        size="small"
                        variant="contained"
                        onClick={() => approveOrReject(2)}
                      >
                        {loading ? "Rejecting..." : "Reject"}
                      </Button>

                      <Button
                        sx={{ boxShadow: "none", color: "white" }}
                        color="success"
                        size="small"
                        variant="contained"
                        onClick={() => approveOrReject(1)}
                        disabled={disabled || loading}
                      >
                        {loading ? "Approving..." : "Approve"}
                      </Button>
                    </Stack>
                  </Box>
                </Form>
              </FormikProvider>
            </>
          )
        ) : null
      }
    />
  );
};

export default WfhActions;
